import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

/**
 * Protects app routes — redirects unauthenticated users to sign-in.
 * An expired or unreadable access token is cleared first so protected
 * pages (including Command Center) never activate on a stale session.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  const sessionExpired = auth.hasExpiredAccessToken();
  if (sessionExpired) {
    auth.expireSession();
  }

  return router.createUrlTree(['/auth/sign-in'], {
    queryParams: {
      returnUrl: state.url,
      ...(sessionExpired ? { sessionExpired: true } : {}),
    },
  });
};
